<template>
  <div class="hotel-card-compact-skeleton">
    <div class="skeleton-image"></div>
    <div class="skeleton-content">
      <div class="skeleton-header">
        <div class="skeleton-title"></div>
        <div class="skeleton-stars"></div>
      </div>
      <div class="skeleton-address"></div>
      <div class="skeleton-amenities">
        <div class="skeleton-amenity"></div>
        <div class="skeleton-amenity"></div>
        <div class="skeleton-amenity"></div>
      </div>
      <div class="skeleton-footer">
        <div class="skeleton-rating">
          <div class="skeleton-badge"></div>
          <div class="skeleton-rating-info">
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
          </div>
        </div>
        <div class="skeleton-price">
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$border-color: var(--grey-border);
$background-color: var(--white);
$image-background: var(--grey);
$placeholder-background: var(--grey-loader-additional);
$shimmer-duration: 1.6s;

@mixin shimmer($base-color) {
  background-color: $base-color;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.35) 50%, rgba(255, 255, 255, 0) 100%);
  background-size: 200% 100%;
  background-repeat: no-repeat;
  animation: shimmer $shimmer-duration ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.hotel-card-compact-skeleton {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  background: $background-color;
  border-radius: 12px;
  border: 2px solid $border-color;
  overflow: hidden;
  height: 420px;
}

.skeleton-image {
  width: 100%;
  height: 200px;
  @include shimmer($image-background);
}

.skeleton-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.skeleton-header {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.skeleton-title {
  width: 60%;
  height: 20px;
  border-radius: 25px;
  @include shimmer($placeholder-background);
}

.skeleton-stars {
  width: 60px;
  height: 12px;
  border-radius: 25px;
  @include shimmer($placeholder-background);
}

.skeleton-address {
  width: 80%;
  height: 14px;
  border-radius: 25px;
  @include shimmer($placeholder-background);
}

.skeleton-amenities {
  display: flex;
  gap: 12px;
}

.skeleton-amenity {
  width: 80px;
  height: 16px;
  border-radius: 25px;
  @include shimmer($placeholder-background);
}

.skeleton-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid $border-color;
}

.skeleton-rating {
  display: flex;
  align-items: center;
  gap: 10px;
}

.skeleton-badge {
  width: 40px;
  height: 32px;
  border-radius: 6px;
  @include shimmer($placeholder-background);
}

.skeleton-rating-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.skeleton-price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.skeleton-line {
  height: 12px;
  border-radius: 25px;
  @include shimmer($placeholder-background);

  &:first-child {
    width: 80px;
  }

  &:last-child {
    width: 60px;
  }
}
</style>
